// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});

// MATCHHEIGHT 
$(function() {
    $('.tykables-slider .slick-slide').matchHeight();
    $('.collection-wrap .product-grid-item').matchHeight();
    $('.js-blog-carousel .article-grid-item').matchHeight();
})

// SEARCH
$('.user-icons').on("click", function (e) {
    $('#search-pop').hide();
});

$("body").on("click", '.js-show-search, .search-close', function (e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if ($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }
    //$('#search-pop').fadeToggle('fast').find('input').focus();
    $('#search-pop').toggleClass('d-flex').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});

// QTY Adjust
/* JS Quantity Incrementers */
jQuery(function () {
    var j = jQuery;
    var addInput = '.js-qty-wrap';

    j(addInput).each(function () {
        var inputEl = j(this).closest(addInput).find('input');
        var n = inputEl.val();
        var plusEl = j(this).closest(addInput).find('.plus');
        var minEl = j(this).closest(addInput).find('.min');
        //On plus click add 1 to n
        plusEl.on('click', function () {
            inputEl.val(++n);
             document.dispatchEvent(new CustomEvent("ItemQuantityChanged",{bubbles:true,detail:inputEl[0]}));
        });
        //On min click
        minEl.on('click', function () {
            //If n is bigger or equal to 1 subtract 1 from n
            if ((inputEl.val()) >= 1) {
                inputEl.val(--n);
            }
             document.dispatchEvent(new CustomEvent("ItemQuantityChanged",{bubbles:true,detail:inputEl[0]}));
        });
    });
});

$('.js-tykables-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows:false,
    dots:true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]

});

$('.js-tykables-slider-alt').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:false,
    dots:true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]

});

// component-testimonial-cards
$('.js-testimonial-cards').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:false,
    dots:true,
    infinite:false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                centerMode: true,
                
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    asNavFor: '.js-slider-thumbs'
});
$('.js-slider-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    variableWidth: false,
    arrows: true,
    prevArrow: '<a href="#" class="previous-arrow" aria-role="button" aria-label="Click to reveal previous slides"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 15L3 8.5L9 2" stroke="#201D1D" stroke-width="4" stroke-linecap="round"/></svg></a>',
    nextArrow: '<a href="#" class="next-arrow" aria-role="button" aria-label="Click to reveal the next slides"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L8 8.5L2 15" stroke="#201D1D" stroke-width="4" stroke-linecap="round"/></svg></a>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        }
    ]
});

// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price

                var selectElement = event.target;
                var selected;
                
                // Check if variant selector type is buttons or select dropdown
                var variantSelectorType = $(this).find('.variant-button').length > 0 ? 'buttons' : 'select';

                if (variantSelectorType === 'select') {
                    selected = selectElement.options[selectElement.selectedIndex];
                } else if (variantSelectorType === 'buttons') {
                    selected = selectElement;
                }
  
                
                var variantPrice = selected.dataset.price;
              
                $('#productPrice').text(variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }

                /** Update Nutritions table tab content */
                if (selected !== undefined > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);

// megamenu grandkids menu
$(document).ready(function () {
    $('.grandchildren').hide();
    $('.child-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.grandchildren').slideUp(200);
});

// Footer Nav
function resizeHandler() {
    console.log("window resized");
    if ($(window).width() < 767) {
        //console.log("window small than 600");
        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}
resizeHandler();
$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

var yourNavigation = $("#shopify-section-header");
    stickyDiv = "sticky";
    yourHeader = $('header').height();

yourNavigation.addClass('sticky');

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader ) {
    yourNavigation.addClass(stickyDiv);
  } else {
    yourNavigation.removeClass(stickyDiv);
  }
});